/* Scroll reveal: section content fades in and rises a little as it scrolls into view.

   Only content that starts below the fold is touched, so the first screen never flashes
   or waits. The bands, background art and stickers stay put; the blocks inside them move,
   which keeps the slanted band seams and section overlaps intact while it runs. Once a
   block has arrived its reveal classes are removed, so it ends up exactly as authored.
   Off in the theme editor, for reduced-motion users, and via the theme setting. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var DURATION = 800; // matches the .oj-reveal transition in base.css
  var STAGGER = 90;
  var MAX_STAGGER_STEPS = 4;
  var NOT_CONTENT = 'style, script, link, template, noscript, [aria-hidden="true"], .oj-section-bg, .oj-stickers';

  function contentChildren(el) {
    return Array.prototype.filter.call(el.children, function (child) {
      return !child.matches(NOT_CONTENT);
    });
  }

  // Rails, the marquee and anything else that clips or scrolls sideways reveal as one
  // block: their items can sit outside the viewport horizontally and would never trigger.
  function clipsInline(el) {
    return el.hasAttribute('data-rail-track') || getComputedStyle(el).overflowX !== 'visible';
  }

  // Walk past single-child wrappers (band > inner) so the stagger runs over the real blocks:
  // the heading, then the cards, rather than the whole section as one slab.
  function targetsFor(section) {
    var targets = contentChildren(section);
    for (var depth = 0; depth < 3 && targets.length === 1; depth++) {
      if (clipsInline(targets[0])) break;
      var children = contentChildren(targets[0]);
      if (!children.length) break;
      targets = children;
    }
    return targets;
  }

  // While it moves, a translated block becomes the containing block for its positioned
  // descendants. Leave anything holding a fixed element alone (the PDP sticky bar), and
  // only fade, without the rise, where an absolutely positioned descendant is anchored
  // outside the block, so nothing jumps at the start or end of the move.
  function motionFor(target) {
    var position = getComputedStyle(target).position;
    if (position === 'fixed') return null;
    var mode = 'rise';
    var descendants = target.querySelectorAll('*');
    for (var i = 0; i < descendants.length; i++) {
      var el = descendants[i];
      var p = getComputedStyle(el).position;
      if (p === 'fixed') return null;
      if (p === 'absolute' && position === 'static' && !target.contains(el.offsetParent)) mode = 'fade';
    }
    return mode;
  }

  function settle(target) {
    target.classList.remove('oj-reveal', 'oj-reveal--fade', 'is-revealed');
    target.style.removeProperty('--oj-reveal-delay');
  }

  var observer = new IntersectionObserver(
    function (entries) {
      var step = 0;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var target = entry.target;
        var delay = Math.min(step++, MAX_STAGGER_STEPS) * STAGGER;
        observer.unobserve(target);
        target.style.setProperty('--oj-reveal-delay', delay + 'ms');
        target.classList.add('is-revealed');
        setTimeout(settle, DURATION + delay + 100, target);
      });
    },
    { rootMargin: '0px 0px -8% 0px' }
  );

  // Read every position first, then write, so the browser lays out once.
  var fold = window.innerHeight;
  var queued = [];
  document.querySelectorAll('main > .shopify-section').forEach(function (section) {
    targetsFor(section).forEach(function (target) {
      if (target.getBoundingClientRect().top < fold) return;
      var mode = motionFor(target);
      if (mode) queued.push({ target: target, mode: mode });
    });
  });

  queued.forEach(function (item) {
    item.target.classList.add('oj-reveal');
    if (item.mode === 'fade') item.target.classList.add('oj-reveal--fade');
    observer.observe(item.target);
  });
})();
